// extracted by mini-css-extract-plugin
export default {"localesBtn":"Locales_localesBtn__jgFBF","activeLang":"Locales_activeLang__Hgwh5"};